import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Fif from './views/Fif.vue'
import Index from './views/Index.vue'
Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: {
        title: 'wee旅天气'
      }
    },
    {
      path: '/:mddid',
      name: 'home',
      component: Home,
      meta: {
        title: 'wee旅天气'
      }
    },
    {
      path: '/:mddid/15',
      name: 'fif',
      component: Fif,
      meta: {
        title: 'wee旅天气'
      }
    }
  ]
})
